<template>
  <div :class="colSpan">
    <dt>
      <ParagraphText font="font-medium" color="text-gray-500">{{
        props.title
      }}</ParagraphText>
    </dt>
    <slot />
  </div>
</template>

<script setup>
import ParagraphText from '@/Common/Text/ParagraphText.vue'
import { computed } from 'vue'

const props = defineProps({
  title: String,
  full: Boolean,
  colSpan: String,
})

const colSpan = computed(() => {
  if (props.colSpan) return props.colSpan

  return props.full ? 'col-span-1 sm:col-span-2' : 'sm:col-span-1'
})
</script>
